import { gql } from '@apollo/client';

/** Latest v3 prediction row with per-bin time series for activity history charts (nested under bin_set like Barn Summary / Inventory). */
export const BIN_SET_PER_BIN_PREDICTION_FOR_HISTORY = gql`
  query BinSetPerBinPredictionForHistory($binSetId: uuid!) {
    bin_set_by_pk(id: $binSetId) {
      id
      bin_set_level_predictions(
        where: {
          deleted_at: { _is_null: true }
          version: { _in: ["3.0"] }
        }
        order_by: { created_at: desc }
        limit: 1
      ) {
        id
        predicted_at
        per_bin_past_feed_inventory_time_series
        per_bin_delivered_deliveries_projection_time_series
        per_bin_scheduled_deliveries_projection_time_series
        per_bin_recommended_deliveries_projection_time_series
        per_bin_level_in_grams
      }
    }
  }
`;

export const BIN_CONTROLLER_FAULT_HISTORY_QUERY = gql`
  query BinControllerFaultHistory($deviceId: uuid!, $faultCodes: [Int!]!, $startTimestamp: bigint!, $endTimestamp: bigint!) {
    fault(
      where: {
        device_id: { _eq: $deviceId }
        code: { _in: $faultCodes }
        deleted_at: { _is_null: true }
        _or:[
          {ended_at:{_is_null:true}, started_at: { _gte: $startTimestamp, _lte: $endTimestamp } }, 
          { started_at: { _lte: $endTimestamp }, ended_at: { _is_null: false, _gte: $startTimestamp } }
         ]
      }
      order_by: [{ started_at: desc }, { order: asc }]
    ) {
      id
      code
      order
      started_at
      ended_at
      details
    }
    fault_before_period: fault(
      where: {
        device_id: { _eq: $deviceId }
        code: { _in: $faultCodes }
        deleted_at: { _is_null: true }
        started_at: { _lt: $startTimestamp }
      }
      order_by: [{ started_at: desc }, { order: asc }]
      limit: 1
    ) {
      id
      code
      order
      started_at
      ended_at
      details
    }
  }
`;

